import { useState, useCallback } from "react";
import { useMutation } from "@tanstack/react-query";
import {
  deliveryApi,
  type OptimizedRoute,
  type RouteOptimizePayload,
} from "@/lib/admin-api/delivery";

// ---------------------------------------------------------------------------
// Hook
// ---------------------------------------------------------------------------

export function useRoutes() {
  const [optimizedRoute, setOptimizedRoute] = useState<OptimizedRoute | null>(null);

  const optimizeMutation = useMutation({
    mutationFn: (payload: RouteOptimizePayload) =>
      deliveryApi.routes.optimize(payload),
    onSuccess: (data) => {
      setOptimizedRoute(data);
    },
  });

  const reset = useCallback(() => {
    setOptimizedRoute(null);
  }, []);

  return {
    optimizedRoute,
    optimize: optimizeMutation.mutate,
    isOptimizing: optimizeMutation.isPending,
    isError: optimizeMutation.isError,
    error: optimizeMutation.error,
    reset,
  } as const;
}
